/**
 * 기간계약 정식 계약서 준비 전까지: 공고 작성·검색(제안) 등에서 기간계약 선택 비활성화.
 * 준비되면 false로 바꿉니다.
 */
export const IS_PERIOD_CONTRACT_SELECTION_DISABLED = true
